import { useLogto } from "@logto/react";
import { useQuery } from "@tanstack/react-query";

import type { LogtoUser } from "@/types/logtoUser";

export const logtoUserQueryKey = ["logtoUser"];

const useLogtoUser = () => {
  const { fetchUserInfo, isAuthenticated } = useLogto();

  return useQuery({
    queryKey: logtoUserQueryKey,
    queryFn: async () => {
      return (await fetchUserInfo()) as LogtoUser;
    },
    enabled: isAuthenticated,
  });
};

export default useLogtoUser;
